module.exports = __webpack_public_path__ + "static/media/Cheque_Upload.ac50a16a.svg";